import React, { useCallback } from "react";
import classes from "./style.module.scss";
import useTranslation from "~/app/hooks/useTranslation";
import Input from "~/app/modules/form/Search/Input";
import { useNotificationContext } from "~/app/hooks/useNotificationContext";

export type SearchComponent = React.FC;

const Search: SearchComponent = () => {
    const { useNotificationState, useNotificationAction, isChat } = useNotificationContext();
    const ns = isChat ? "chat" : "notifications";
    const { t } = useTranslation(ns);
    const isSearching = useNotificationState((state) => state.isSearching);
    const setIsSearching = useNotificationAction((actions) => actions.setIsSearching);
    const setNotificationPayload = useNotificationAction((actions) => actions.setNotificationPayload);
    const notificationPayload = useNotificationState((state) => state.notificationPayload);
    const setFetching = useNotificationAction((actions) => actions.setFetching);

    const searchFormSearchHandler = useCallback(
        (value: string): void => {
            setIsSearching(true);
            setNotificationPayload({
                ...notificationPayload,
                offset: 0,
                searchText: value
            });
            setFetching(true);
        },
        [notificationPayload, setIsSearching, setNotificationPayload, setFetching]
    );
    
    return (
        <div className={classes["search-wrap"]}>
            <Input
                placeholder={t("search")}
                className={classes["field"]}
                inputClassName={classes["input"]}
                onSearch={searchFormSearchHandler}
                fetching={isSearching}
                value={notificationPayload.searchText}
                iconPosition='left'
            />
        </div>
    );
};

export default Search;
